import { render, staticRenderFns } from "./QuotesTabs.vue?vue&type=template&id=3cf55b49&scoped=true&"
import script from "./QuotesTabs.vue?vue&type=script&lang=js&"
export * from "./QuotesTabs.vue?vue&type=script&lang=js&"
import style0 from "./QuotesTabs.vue?vue&type=style&index=0&id=3cf55b49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf55b49",
  null
  
)

export default component.exports